import { render, staticRenderFns } from "./rushGood.vue?vue&type=template&id=9b0e81a2&scoped=true&"
import script from "./rushGood.vue?vue&type=script&lang=js&"
export * from "./rushGood.vue?vue&type=script&lang=js&"
import style0 from "./rushGood.vue?vue&type=style&index=0&id=9b0e81a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0e81a2",
  null
  
)

export default component.exports